/**
 * What one page of a collection withholds: the arithmetic every surface that says "showing N of M"
 * shares (F-0063, I-0190, I-0552). The CLI's paging contract (`featit list`, `inbox`, `activity`)
 * and the app's notification list both call it, so a figure cannot be worded one way in a terminal
 * and computed another in the bell's dropdown.
 */
export interface IPageCounts {
  /** Items on this page. */
  shown: number;
  /** Items the earlier pages of this walk already showed; 0 on the first page. */
  preceding: number;
  /** The server's count of the population being listed, or null where it is not honestly knowable. */
  total: number | null;
}

/**
 * Items this page withheld, or null when the total that would answer it is not knowable. Never
 * negative: a list that outgrew its total (a notification arrived since it was counted) withholds
 * none rather than a negative number.
 */
export function withheldCount(counts: IPageCounts): number | null {
  if (counts.total === null) return null;
  return Math.max(0, counts.total - counts.preceding - counts.shown);
}
